export const REGISTER_ACTIVITY = "REGISTER_ACTIVITY";
export const REGISTER_MENU_ACTIVITY = "REGISTER_MENU_ACTIVITY";
export const TOGGLE_TIMEOUT_DISABLED = "TOGGLE_TIMEOUT_DISABLED";
export const TOGGLE_TIMEOUT_ACTIVE = "TOGGLE_TIMEOUT_ACTIVE";
